import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { delimiterSeparatedToTitleCase } from 'Utils';
import NavSideBarListItem from './NavSideBarListItem';
import NavSideBarListSectionHeader from './NavSideBarListSectionHeader';

export default class NavSideBarListSection extends React.PureComponent {
  constructor(props) {
    super(props);

    this.getCategoryListItem = this.getCategoryListItem.bind(this);
    this.getNavSideBarListSection = this.getNavSideBarListSection.bind(this);
  }

  getCategoryListItem(section, screenIdx) {
    const sectionTitleCase = delimiterSeparatedToTitleCase('_', section);
    const className = classnames(this.props.categoryListItemClassName, {
      active: this.props.onStep === screenIdx,
    });

    return (
      <NavSideBarListItem
        className={className}
        documentType={this.props.documentType}
        key={`section-${screenIdx}`}
        loadStaticBuilderSection={this.props.loadStaticBuilderSection}
        offsiteBuilder={this.props.offsiteBuilder}
        screenIdx={screenIdx}
        section={sectionTitleCase}
        title={(screenIdx + 1).toString()}
      />
    );
  }

  getNavSideBarListSection() {
    const navSideBarListSection = [];
    const numOfSections = this.props.sections.length;
    for (let i = 0; i < numOfSections; i += 1) {
      const section = this.props.sections[i];
      const screenIdx = this.props.offsetIdx + i;
      const navSideBarListItem = this.getCategoryListItem(section, screenIdx);
      navSideBarListSection.push(navSideBarListItem);
    }

    return navSideBarListSection;
  }


  render() {
    const navSideBarListSection = this.getNavSideBarListSection();
    const categoryTitleCase = delimiterSeparatedToTitleCase('_', this.props.category).trim();
    const screenIdx = this.props.offsetIdx + this.props.sections.length;
    const requestSignatureNavSideBarListItem = this.getCategoryListItem('request_signature', screenIdx);

    const isSectionHeaderActive = (
      this.props.offsetIdx <= this.props.onStep &&
      this.props.onStep < (this.props.offsetIdx + this.props.sections.length)
    );

    return (
      <React.Fragment
        key={categoryTitleCase}
      >
        <NavSideBarListSectionHeader
          className={classnames({
            active: isSectionHeaderActive && !this.props.offsiteBuilder,
          })}
          key={`${categoryTitleCase}_heading`}
        >
          {this.props.category}
        </NavSideBarListSectionHeader>
        {navSideBarListSection}
        {this.props.showRequestSignature &&
          requestSignatureNavSideBarListItem
        }
      </React.Fragment>
    );
  }
}


NavSideBarListSection.defaultProps = {
  categoryListItemClassName: '',
  offsetIdx: 0,
  offsiteBuilder: false,
  onStep: 0,
  sections: [],
  showRequestSignature: false,
};

NavSideBarListSection.propTypes = {
  category: PropTypes.string.isRequired,
  categoryListItemClassName: PropTypes.string,
  documentType: PropTypes.string.isRequired,
  loadStaticBuilderSection: PropTypes.func.isRequired,
  offsetIdx: PropTypes.number,
  offsiteBuilder: PropTypes.bool,
  onStep: PropTypes.number,
  sections: PropTypes.arrayOf(PropTypes.string),
  showRequestSignature: PropTypes.bool,
};




// WEBPACK FOOTER //
// ./src-react/StaticBuilder/NavSideBarList/NavSideBarListSection.jsx